var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs"},[[_c('ApolloQuery',{attrs:{"query":_vm.query,"variables":{ id: _vm.folder._id }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var error = ref_result.error;
var data = ref_result.data;
return [(loading)?_c('div',{staticClass:"loading apollo"},[_c('BreadcrumbsChild',{attrs:{"folder":_vm.folder,"first":true}})],1):(data && data.findFolderByID)?_c('div',{staticClass:"breadcrumbs__result apollo"},[_c('BreadcrumbsChild',{attrs:{"folder":data.findFolderByID,"first":true}})],1):_vm._e()]}}])})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }